import { errorVariantStyles, infoVariantStyles, promotionVariantStyles, successVariantStyles, warningVariantStyles, } from './notification-variants.styled';
export const getNotificationVariantStyles = (variant) => variant &&
    {
        info: infoVariantStyles,
        success: successVariantStyles,
        error: errorVariantStyles,
        warning: warningVariantStyles,
        promotion: promotionVariantStyles,
    }[variant];
//# sourceMappingURL=helpers.js.map